import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@shared/utils';
import { AccountResponse, CardResponse, UserType } from '@shared/api';
import { SmallAccount } from './smallAccount';
import { SmallCard } from './smallCard';
import { Button, Icon, Text } from '@shared/widgets';
import PlusIcon from '@assets/icons/plus.svg';

interface UserLongInfoItemProps {
  show: boolean;
  type: UserType;
  icon: React.ReactNode;
  userId: string;
  cards?: CardResponse[];
  accounts?: AccountResponse[];
  showAddModal: () => void;
  removeItem: (id: number) => void;
}

export const UserLongInfoItem = (props: UserLongInfoItemProps) => {
  const { t } = useTranslation('userManagement');

  const isManager = useMemo(() => props.type === UserType.MANAGER, [props.type]);
  return (
    <div className={cn('border-t border-t-gray-black px-6 pb-8 pt-5', props.show ? 'block' : 'hidden')}>
      <div className='mb-6 flex items-center justify-between'>
        <div className='flex items-center'>
          <div className='mr-3 flex h-8 w-8 flex-none items-center justify-center bg-ice dark:bg-eerie-black'>{props.icon}</div>
          <Text weight='medium' size='sm'>
            {t(`user.info.userType.${isManager ? 'manager' : 'user'}`, { count: isManager ? props.accounts?.length : props.cards?.length })}
          </Text>
        </div>
        <Button color='outlined' className='flex h-8 w-8 flex-none items-center justify-center rounded !p-0 text-center' onClick={props.showAddModal}>
          <Icon icon={<PlusIcon />} color='inherit' />
        </Button>
      </div>
      {props.accounts && props.accounts.map((account) => <SmallAccount key={account.id} account={account} removeAccount={props.removeItem} />)}
      {props.cards && props.cards.map((card) => <SmallCard key={card.cardId} card={card} removeCard={props.removeItem} />)}
    </div>
  );
};
